module.exports = __webpack_public_path__ + "img/illu-rocks.f158cc5b.svg";